import { useEffect } from 'react';
import { AiPoweredRequestsData, ExtraItem, GeneralSettingsData, PackSettings, ReportsSettingsData } from '../../models';
import { useDispatch, useSelector } from 'react-redux';
import { getExpensesAvailableForAppoinementType, getGeneralSettings, getLatestPackTemplates, getPackTemplates, isPackTemplatesLoading } from './selectors';
import { loadPackTemplates, loadPackTemplateVersion } from './actions';
import { ApplicationState } from '..';

export const useEntitiesPageSizeSetting = (): number =>
    useSelector<ApplicationState, number>(state => state.settings.entities.pageSize);


export const useRoomsSet = (): string[] =>
    useSelector<ApplicationState, string[]>(state => Object.keys(state.settings?.general?.rooms ?? {}));

export const useServicesSet = (): string[] =>
    useSelector<ApplicationState, string[]>(state => Object.keys(state.settings?.general?.services ?? {}));

export const useGeneralSettings = (): GeneralSettingsData =>
    useSelector<ApplicationState, GeneralSettingsData>(state => state.settings.general);

export const useAIPoweredRequests = (): AiPoweredRequestsData =>
    useSelector<ApplicationState, AiPoweredRequestsData>(state => state.settings.aiPoweredRequests);

export const usePacksSettings = (): PackSettings[] => {
    const dispatch = useDispatch();
    const templates = useSelector(getLatestPackTemplates) ?? [];
    useEffect(() => { dispatch(loadPackTemplates()); }, [dispatch]);
    return templates;
};

export const usePackSettings = (templateId: string, version: number): PackSettings|undefined => {
    const dispatch = useDispatch();
    const templates = useSelector(getPackTemplates);
    const storeLoading = useSelector(isPackTemplatesLoading);
    const template = templates?.find(t => t.templateId === templateId && t.version === version);

    useEffect(() => { dispatch(loadPackTemplates()); }, [dispatch]);

    useEffect(() => {
        if (!templateId || version == null || storeLoading || template) return;
        dispatch(loadPackTemplateVersion(templateId, version));
    }, [dispatch, templateId, version, storeLoading, template]);

    return template;
};

export const useServicesSettings = (): GeneralSettingsData['services'] => 
    useSelector<ApplicationState, GeneralSettingsData['services']>(state => getGeneralSettings(state)?.services ?? {});

export const useExpensesAvailable = (appointmentType: string | string[]): ExtraItem[] =>
    useSelector<ApplicationState, ExtraItem[]>(state => getExpensesAvailableForAppoinementType(state, appointmentType));

export const useReportsSettings = (): ReportsSettingsData => 
    useSelector<ApplicationState, ReportsSettingsData>(state => state.settings.reports);
